import { urlHelper } from '@/helpers/apiHelpers/urlHelper';
import { MASTER_ADMIN_URL_PREFIX } from '@/const/shared';

export const getDevelopersPath = () => {
  return urlHelper(`${MASTER_ADMIN_URL_PREFIX}/developers`);
};
